<template>
  <div class="relative w-screen bg-[--header-bottom-bg-color] -ml-4 -mr-4" >
    <nav class="w-full h-12">
      <div class="w-full px-6 lg:px-12 h-full flex items-center">
        <nav class="ml-auto flex items-center gap-6 text-sm font-medium">
          <li v-for="item in desktopMainMenuItems.filter(i =>
            i.id && ['compare', 'cart', 'notifications', 'orders','dashboard'].includes(i.id) &&
            !(i.id === 'notifications' && !isNotificationsVisible))"
            :key="item.id"
            class="list-none flex items-center h-full relative"
          >
            <!-- Compare -->
            <BottomHeaderLink
              v-if="item.id === 'compare'"
              class="uppercase"
              :link="item"
              :count="productsIds.length"
            >
              {{ item.title }}
            </BottomHeaderLink>

            <!-- Cart -->
            <BottomHeaderLink
              v-else-if="item.id === 'cart'"
              :link="item"
              :count="cart?.itemsQuantity"
              class="uppercase"
            >
              {{ item.title }}
            </BottomHeaderLink>

            <!-- Push messages -->
            <PushMessages
              v-else-if="item.id === 'notifications'"
              :offset-options="20"
            >
              <template #trigger="{ totalCount, unreadCount }">
                <BottomHeaderLink :link="item" :count="unreadCount" class="uppercase gap-3">
                  <template #icon>
                    <transition :name="unreadCount ? 'shake' : ''">
                      <svg
                        v-if="item.icon"
                        :key="totalCount"
                        height="24"
                        width="24"
                        class="text-secondary"
                      >
                        <use :href="item.icon" />
                      </svg>
                    </transition>
                  </template>
                  {{ item.title }}
                </BottomHeaderLink>
              </template>
            </PushMessages>

            <!-- Default -->
            <BottomHeaderLink v-else :link="item" class="uppercase">
              {{ item.title }}
            </BottomHeaderLink>
          </li>
        </nav>

      </div>
    </nav>
  </div>
</template>
<script setup lang="ts">
import { onClickOutside, syncRefs, useScrollLock } from "@vueuse/core";
import { ref, shallowRef, computed } from "vue";
import { useNavigations } from "@/core/composables";
import { useUser } from "@/shared/account/composables/useUser";
import { useShortCart } from "@/shared/cart";
import { useCompareProducts } from "@/shared/compare";
import { usePushMessages } from "@/shared/push-messages/composables/usePushMessages";
import BottomHeaderLink from "./bottom-header-link.vue";
import PushMessages from "@/shared/push-messages/components/push-messages.vue";
const { isAuthenticated } = useUser();
const { cart } = useShortCart();
const { desktopMainMenuItems } = useNavigations();
const { productsIds } = useCompareProducts();
const { isActive: isPushMessagesActive } = usePushMessages();
import { getCurrentInstance } from "vue";


const catalogMenuElement = shallowRef<HTMLElement | null>(null);
const showCatalogMenuButton = shallowRef<HTMLElement | null>(null);
const catalogMenuVisible = ref(false);
const { appContext } = getCurrentInstance()!;

const appSettings = appContext.config.globalProperties.$cfg;

const isNotificationsVisible = computed(() => {
  return (
    appSettings.push_messages_enabled === true &&
    isAuthenticated.value === true &&
    isPushMessagesActive === true
  );
});

onClickOutside(
  catalogMenuElement,
  () => {
    catalogMenuVisible.value = false;
  },
  { ignore: [showCatalogMenuButton] },
);

syncRefs(catalogMenuVisible, useScrollLock(document.body));

</script>

<style lang="scss" scoped>
.app-name {
  font-size: 18px;
}
</style>
